import store from '@/core/store';
import { computed } from '@vue/composition-api';
import { get, set } from 'lodash-es';

function generateVuexPropertieHook (name, alias) {
  let cache;
  return () => {
    if (!cache) {
      cache = computed({
        get: () => get(store, `state.webPanel[${name}]`),
        set: val => store.commit('webPanel/set', state => { set(state, name, val); }),
      });
    }
    return {
      [alias || name]: cache,
    };
  };
}

const useLoading = generateVuexPropertieHook('loading');
const useTitle = generateVuexPropertieHook('title');
const useFocusMode = generateVuexPropertieHook('focusMode');
const useShowHeader = generateVuexPropertieHook('showHeader');
const useIsNavigationEnabled = generateVuexPropertieHook('navMenu.enabled', 'isNavigationEnabled');
const useIsNavigationOpen = generateVuexPropertieHook('navMenu.open', 'isNavigationOpen');

export const useWebPanel = () => {
  // const shouldShowNavigation = computed(() => {
  //   const { isNavigationOpen } = useIsNavigationOpen();
  //   const { focusMode } = useFocusMode();
  //   return !focusMode || isNavigationOpen;
  // });
  return {
    ...useTitle(),
    ...useFocusMode(),
    ...useLoading(),
    ...useShowHeader(),
    ...useIsNavigationEnabled(),
    ...useIsNavigationOpen(),
    // shouldShowNavigation,
  };
};
